import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import OrganisationStore from '../stores/OrganisationStore';
import UserListCell from './UserListCell';


export interface Props {
    match: {
        params: {
            id: string;
        };
    };
}

interface State {
    loading: boolean;
}

@observer export default class OrganisationDetailView extends React.PureComponent<Props, State> {
    @observable users: Array<any> = [];
    @observable emails: string = '';

    componentDidMount() {
        this._listUsers();
    }

    render() {
        return (
            <div>
                <h1>Organisation Detail</h1>
                <h2>Add Users</h2>
                <form onSubmit={this._onSubmit}>
                    <div className="form-group">
                        <label htmlFor="emailsInput">Emails Separated by comma</label>
                        <textarea className="form-control" id="emailsInput" value={this.emails} onChange={this._onEmailsChange}/>
                    </div>
                    <button type="submit" className="btn btn-primary">Add Users</button>
                </form>
                <hr/>
                <h2>Users</h2>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Joined At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.users.map(i => <UserListCell key={i.user.user_id} organisation_user={i} />)}
                    </tbody>
                </table>
            </div>
        );
    }

    _listUsers = () => {
        const { match: { params: { id } } } = this.props;

        OrganisationStore.getUsers(id)
        .then((users) => {
            this.users = users;
        })
        .catch(() => {
            // Show error and clear code
            alert('Failed to list users');
        });
    }

    _onEmailsChange = ({ target: { value } }) => {
        this.emails = value;
    }

    _onSubmit = e => {
        e.preventDefault();

        const { match: { params: { id } } } = this.props;

        OrganisationStore.sendInvites(id, this.emails)
        .then(() => {
            alert('Users added');
            this.emails = '';
            this._listUsers();
        })
        .catch(() => {
            // Show error and clear code
            alert('Failed to add users');
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/OrgnisationDetailView.tsx